/**
 * Created by XuQiang on 2017/5/25.
 */
import ReservationDialog from './ReservationDialog';
import { Modal } from 'antd';

export default ({ type, message, title, locale }) => {
  return new Promise(resolve => {
    ReservationDialog({
      type,
      message,
      title,
      locale,
      onClose: e => resolve(e)
    });
  });
};

export const openErrorDialog = ({ message, title }) => {
  return new Promise(resolve => {
    const ref = Modal.error({
      title: title,
      okText: '确定',
      content: message,
      onOk: e => {
        ref.destroy();
        resolve(e);
      }
    });
  });
};



// WEBPACK FOOTER //
// ./src/components/commons/ScheduleDialog.js